import { Serializer } from '../resource/serializer.interface';
import { PreferenceAgent } from './preference-agent.model';

export class PreferenceAgentSerializer implements Serializer {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public fromJson(json: any): PreferenceAgent {
    const agent: PreferenceAgent = new PreferenceAgent();
    agent.behavior = json.behavior;
    agent.businessUnit = json.businessUnit;
    agent.createdAt = json.created_at;
    agent.data = json.data;
    agent.description = json.description;
    agent.design = json.design;
    agent.elements = json.elements ?? [];
    agent.farewell = json.farewell;
    agent.id = json.id;
    agent.name = json.name;
    agent.redirectUrl = json.redirectUrl;
    agent.slug = json.slug;
    agent.status = json.status;
    agent.tenantId = json.tenant_id;
    agent.updatedAt = json.updated_at;
    agent.welcome = json.welcome;
    return agent;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public toJson(agent: PreferenceAgent): any {
    return {
      behavior: agent.behavior,
      businessUnit: agent.businessUnit,
      data: agent.data,
      description: agent.description,
      design: agent.design,
      elements: agent.elements,
      farewell: agent.farewell,
      id: agent.id,
      name: agent.name,
      redirectUrl: agent.redirectUrl,
      slug: agent.slug,
      status: agent.status,
      welcome: agent.welcome
    };
  }
}
